import { useEffect, useMemo } from 'react';
import { presenceApi } from '../api/presence-api';
import { CharacterPresenceController } from '../stores/character-presence-controller';
import type { ForegroundSource, PresenceApi } from '../types/presence.types';
const browserSource: ForegroundSource = {
  isVisible: () => typeof document !== 'undefined' && document.visibilityState === 'visible',
  subscribeAction(listener) {
    const action = (event: Event) => listener(event.isTrusted);
    document.addEventListener('pointerdown', action);
    document.addEventListener('keydown', action);
    return () => { document.removeEventListener('pointerdown', action); document.removeEventListener('keydown', action); };
  },
  subscribeVisibility(listener) {
    const change = () => listener(browserSource.isVisible());
    document.addEventListener('visibilitychange', change);
    return () => document.removeEventListener('visibilitychange', change);
  },
};
export function useCharacterPresence({ heroId, enabled, api = presenceApi }: {
  heroId: number | null; enabled: boolean; api?: PresenceApi;
}) {
  const controller = useMemo(() => new CharacterPresenceController(api, browserSource, {
    setTimeout: (callback, delay) => setTimeout(callback, delay), clearTimeout: timer => clearTimeout(timer),
  }), [api]);
  useEffect(() => {
    if (heroId === null || !enabled) return;
    controller.start();
    return controller.stop;
  }, [controller, heroId, enabled]);
}
